import React, { useEffect } from "react";
import "./EducationPage.css";

const SportsPage = () => {

  useEffect(() => {
    const cards = document.querySelectorAll(".card-wrapper");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            requestAnimationFrame(() => {
              entry.target.classList.add("show");
            });
          } else {
            entry.target.classList.remove("show");
          }
        });
      },
      {
        threshold: 0.45,
        rootMargin: "0px 0px -150px 0px",
      }
    );

    cards.forEach((card) => observer.observe(card));

    return () => {
      cards.forEach((card) => observer.unobserve(card));
    };
  }, []);

  const sportsData = [
    {
      title: "Techno India Manchester City Football School",
      desc: (
        <p>
          "An attempt to transform the grassroot football ecosystem in India, couldn’t have been
          bigger and better – in close collaboration with the world-famous City Football Group.
          Blessed with City Group’s unrivalled experience of successfully running football
          academies around the world and bolstered with the presence of seasoned coaches, world-
          class training facilities and latest sports technologies, TIG Man City Football School
          rekindles a nation’s long-shared dream of appearing at football’s greatest stage. From 3
          to 17 years old, raw talents are nurtured with utmost care and their skills are honed in the
          most scientific manner.  ​"
        </p>
      ),
      img: "/images/ecosystem/ManCity.jpg",
      link: "https://tigmancity.com/"
    },
    // {
    //   title: "UKSC Academy",
    //   desc: (
    //     <p>
    //       "Lorem Ipsum is simply dummy text of the printing and typesetting industry..."
    //     </p>
    //   ),
    //   img: "/images/ecosystem/UKSC.jpg",
    //   link: "#"
    // },
  ];

  return (
    <div>

      <div className="inner-banner-wrapper">
        <img
          src="/images/page-banner/about.png"
          alt="Banner"
          className="inner-banner-img"
        />
        <div className="inner-banner-overlay">
          <div className="inner-banner-text">Sports</div>
        </div>
      </div>

      <div className="overview-container">
        <div className="contain-body">

          {sportsData.map((item, index) => (
            <div
              className={`card-wrapper ${index % 2 === 1 ? "reverse" : ""}`}
              key={index}
            >
              <div className="card-text">
                <h2>{item.title}</h2>
                {item.desc}

                <a
                  href={item.link}
                  target="_blank"
                  rel="noreferrer"
                  className="learn-more-link"
                >
                  <span className="learn-more-icon">➜</span>
                  <span>Learn more</span>
                </a>
              </div>

              <div className="card-image">
                <img src={item.img} alt={item.title} />
              </div>
            </div>
          ))}

        </div>
      </div>

    </div>
  );
};

export default SportsPage;